
 document.addEventListener("DOMContentLoaded", function () {
    const container = document.querySelector(".image-with-text--desc p");
    if (!container) return;

    const text = container.textContent.trim();
    const words = text.split(" ");
    const wordsPerLine = 8; // Adjust this for how many words per line
    const lines = [];

    for (let i = 0; i < words.length; i += wordsPerLine) {
      lines.push(words.slice(i, i + wordsPerLine).join(" "));
    }

    container.innerHTML = lines
      .map((line, index) => `<span class="text-line" style="transition-delay: ${index * 0.2}s">${line}</span>`)
      .join("");

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          } else {
            entry.target.classList.remove("visible");
          }
        });
      },
      {
        threshold: 0.8,
        rootMargin: "0px 0px -10% 0px"
      }
    );

    document.querySelectorAll(".image-with-text--desc .text-line").forEach(el => {
      observer.observe(el);
    });
  });

jQuery(document).ready(function($){
 $('#product-7171661529134').parent().addClass("product-7171661529134");
  
 $('#product-7171661725742').parent().addClass("product-7171661725742");
 $('#product-7171661692974').parent().addClass("product-7171661692974");  
})